import { Typography } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { useFormatPersonName } from "../../hooks/useNameFormat";
import { NEUTRAL, STATUS_BADGE } from "../../theme/tokens";
import type { Nurse } from "../../utils/models";
import { VirtualizedList } from "../UIToolkit/molecules/VirtualizedList";
import SystemButton from "../UIToolkit/SystemButton/SystemButton";

type Props = {
	nurses?: Nurse[];
};

export const MobileStaffList: FC<Props> = ({ nurses }) => {
	const { chosenDepartment } = useHospitalData();
	const formatPersonName = useFormatPersonName();
	const navigate = useNavigate();
	const goToNurseProfile = (nurseId: number) => {
		navigate(`/${chosenDepartment.department_id}/nurse/${nurseId}`);
	};
	return !nurses || nurses.length === 0 ? (
		<Typography
			sx={{
				color: STATUS_BADGE.LILAC_INK,
				fontSize: 32,
			}}
		>
			No nurses found.
		</Typography>
	) : (
		<VirtualizedList
			sx={{
				width: "100%",
				height: "100%",
				padding: 1,
			}}
			items={(nurses || []).sort((a, b) => formatPersonName(a).localeCompare(formatPersonName(b)))}
			rowHeight={45}
			itemWrapperSx={{
				borderBottom: `1px solid ${NEUTRAL[300]}`,
				display: "flex",
				alignItems: "center",
			}}
			renderItem={(nurse) => (
				<SystemButton
					sx={{
						backgroundColor: "transparent",
						justifyContent: "start",
						width: "100%",
					}}
					buttonVariant={"borderless"}
					onClick={(_) => {
						goToNurseProfile(nurse.id);
					}}
				>
					{formatPersonName(nurse)}
				</SystemButton>
			)}
		/>
	);
};
